import React from 'react';
import { styled, SxProps, Theme } from '@mui/material/styles';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Favicon from 'icons/Favicon.icon';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '20px',
  boxShadow: '0px 12px 64px 0px #02011108',
  padding: '24px',
  maxWidth: '463px',
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    padding: '48px',
  },
}));

type AuthCardProps = {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};

const AuthCard: React.FC<AuthCardProps> = ({ children, sx }) => {
  return (
    <StyledCard sx={sx}>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
          gap: 2,
          height: '100%',

          ':last-child': {
            padding: 0,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Favicon />
          <Typography variant="h3">Interviewer</Typography>
        </Box>

        {children}
      </CardContent>
    </StyledCard>
  );
};

export default AuthCard;
